/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var geoStandardOptions = Object.create(null);
geoStandardOptions.enableHighAccuracy = false;
geoStandardOptions.timeout = 0xFFFFFFFF;
geoStandardOptions.maximumAge = 0;
var geolocationStandardOptions = Object.freeze(geoStandardOptions);

exports.default = geolocationStandardOptions;
